module.exports = "/packs/images/ku-loader~65c7bd844803875afb5ac61ef9db4150.gif";